import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/txm',
    name: 'txm',
    component: () => import('../views/Txm.vue')
  },
  {
    path: '/img',
    name: 'img',
    component: () => import('../views/ImgFormat.vue')
  },
  {
    path: '/json',
    name: 'json',
    component: () => import('../views/JsonFormat.vue')
  }, {
    path: '/excel',
    name: 'excel',
    component: () => import('../views/ExcelFormat.vue')
  }, {
    path: '/javaFormarts',
    name: 'javaFormarts',
    component: () => import('../views/JavaFormartTest.vue')
  }
  , {
    path: '/test3',
    name: 'test3',
    component: () => import('../views/test3.vue')
  },

  
  
  
]

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })
const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_BASE_URL,
  routes
})
export default router
